import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    fullName,
    chiefAccountant,
    signer,
    timeSign,
    accountingService,
    certificate,

    taxpayersName,
    taxpayersId,

    taxAgentName,
    taxAgentId,

    tctm,
    bctc,
    htldl,
    auditOpinion,
  },
} = checkout;

const validation = Yup.object().shape({
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [chiefAccountant.name]: Yup.string().required(chiefAccountant.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [taxpayersName.name]: Yup.string().required(taxpayersName.errorMsg),
  [accountingService.name]: Yup.string().required(accountingService.errorMsg),
  [taxAgentName.name]: Yup.string().notRequired(taxAgentName.errorMsg),
  [bctc.name]: Yup.string().notRequired(bctc.errorMsg),
  [htldl.name]: Yup.string().notRequired(htldl.errorMsg),
  [tctm.name]: Yup.string().notRequired(tctm.errorMsg),
  [auditOpinion.name]: Yup.string().notRequired(auditOpinion.errorMsg),

  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [certificate.name]: Yup.number().required(certificate.errorMsg),

  [taxpayersId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxpayersId.invalidMsg)
    .required(taxpayersId.errorMsg),
  [taxAgentId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentId.invalidMsg)
    .notRequired(taxAgentId.errorMsg),
});

export default validation;
